import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, throwError, of, BehaviorSubject } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getPropertyCarousel(): Observable<any> {
    return this.http.get(`${environment.api_URL}/dashboard/carousel`).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (!this.isBrowser()) {
          return of({ status: false, message: 'SSR mode' });
        }
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error,
        }));
      })
    );
  }
  addSubscriber(email:string): Observable<any> {
    return this.http.post(`${environment.api_URL}/dashboard/subscription`,{email:email}).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (!this.isBrowser()) {
          return of({ status: false, message: 'SSR mode' });
        }
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error,
        }));
      })
    );
  }
  talkToExpertNotifiction(data:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/dashboard/exnotification`,data).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (!this.isBrowser()) {
          return of({ status: false, message: 'SSR mode' });
        }
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error,
        }));
      })
    );
  }
  contactUsNotifiction(data:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/dashboard/contUSNoti`,data).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (!this.isBrowser()) {
          return of({ status: false, message: 'SSR mode' });
        }
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error,
        }));
      })
    );
  }

  searchProperty(id:any): Observable<any> {
    return this.http.get(`${environment.api_URL}/property/propSearch?key=${id}`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      return `Network error: ${error.error.message}`;
    }

    // Backend returned an unsuccessful response code
    // NestJS usually sends: { message: "...", error: "...", statusCode: 400 }
    if (error.error && error.error.message) {
      return Array.isArray(error.error.message)
        ? error.error.message[0] // Handle class-validator arrays
        : error.error.message;
    }

    return `Server Error: ${error.statusText || 'Internal Server Error'}`;
  }
}
